import { useMutation, useQuery, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';
import { getCredentials, createCredentials, CreateCredentialsPayload } from 'services/credentials.service';

export const getCredentialsQueryKey = 'getCredentials';

export const useCredentials = () => useQuery(
  getCredentialsQueryKey,
  () => {
    console.log('[useCredentials] fetching...');
    return getCredentials().then((r: AxiosResponse) => {
      console.log('[useCredentials] response:', r.data);
      return r.data;
    });
  },
  {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
    onError: (e) => console.log('[useCredentials] error:', e),
  },
);

export const useCreateCredentials = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: CreateCredentialsPayload) => createCredentials(data),
    { onSuccess: () => queryClient.invalidateQueries(getCredentialsQueryKey) },
  );
};
